import Slider from "@material-ui/core/Slider";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";

import useContext from "../../../context";
import { getSliderOptions } from "../../../loanConfig";

export default function DownPayment() {
  const [context, updateContext] = useContext();

  const dollars = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    trailingZeroDisplay: 'stripIfInteger',
  });

  // Outdated or made-up amounts would mislead; disable the slider until current ones arrive
  const options = getSliderOptions(context, 'downPayment');
  const pendingLabel = context.response.loading ? '…' : '';

  return (
    <React.Fragment>
      <div className="quoteform__input-group">
        <div className="quoteform__heading">Down Payment <span className="small light">No Credit Check Option</span></div>
        <div className="quoteform__text">Tell us how much of a down payment you're comfortable with.</div>
        <div className="quoteform__input quoteform__input-slider" aria-busy={!options && context.response.loading}>
          <div className="slider">
            <Slider
              aria-label="Down payment no credit check option"
              value={context.downPaymentOption}
              disabled={!options}
              marks={[1, 2, 3].map((value) => ({ value, label: options ? dollars.format(options[value - 1]) : pendingLabel }))}
              min={1}
              max={3}
              step={1}
              onChange={(e, val) => updateContext((ctx) => {
                ctx.downPaymentOption = val;

                return ctx;
              })}
            />
          </div>
        </div>
      </div>
      {
        !context.sellerPaysClosingCosts && (
          <div className="quoteform__input-group">
            <div className="quoteform__heading">Finance Closing Costs</div>
            <div className="quoteform__input">
              <FormControlLabel
                className="MuiCheckbox-root--alignstart"
                label={<div className="quoteform__text" style={{ color: "#000" }}>Finance the maximum amount of my closing costs</div>}
                control={
                  <Checkbox
                    color="primary"
                    disabled={context.sellerPaysClosingCosts}
                    checked={context.financeClosingCosts}
                    onChange={({ target: { checked } }) => updateContext((ctx) => {
                      ctx.financeClosingCosts = checked;

                      return ctx;
                    })}
                    value={'yes'}
                    name="finance-closingcosts"
                  />
                }
              />
            </div>
          </div>
        )
      }
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/DownPayment.js